<template>
    <div id="FlyingPlatform">
        <view1/>
        <view2/>
        <view3/>
    </div>
</template>
<script> 
export default {
  name: 'FlyingPlatform',
  components: {
    // 异步加载子组件
    view1: () => import('@/views/FlyingPlatform/view1.vue'),
    view2: () => import('@/views/FlyingPlatform/view2.vue'),
    view3: () => import('@/views/FlyingPlatform/view3.vue')
  }
}
</script>